import { render, staticRenderFns } from "./UiIconButton.vue?vue&type=template&id=25cc0b2c"
import script from "./UiIconButton.vue?vue&type=script&lang=js"
export * from "./UiIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports